class HmProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.current = this.panels.findIndex((panel) => panel.classList.contains('is-active'));
    if (this.current < 0) this.current = 0;
    this.busy = false;
    this.queued = null;
    if (this.tabs.length < 2) return;
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => this.onKey(event, index));
    });
  }

  reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  animMs() {
    const raw = getComputedStyle(this).getPropertyValue('--hm-pf-tab-ms').trim();
    const n = Number.parseInt(raw, 10);
    return Number.isFinite(n) ? n : 420;
  }

  select(index, { focus = false } = {}) {
    if (index === this.current) return;
    if (this.busy) {
      this.queued = index;
      return;
    }

    const from = this.panels[this.current];
    const to = this.panels[index];
    if (!from || !to) return;

    this.tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    this.dataset.active = String(index);

    const dir = index > this.current ? 1 : -1;
    this.style.setProperty('--hm-pf-dir', `${dir * 22}px`);

    if (this.reducedMotion() || this.getAttribute('data-tab-anim') === 'false') {
      from.classList.remove('is-active', 'is-leaving', 'is-entering');
      from.setAttribute('hidden', '');
      from.setAttribute('aria-hidden', 'true');
      to.removeAttribute('hidden');
      to.setAttribute('aria-hidden', 'false');
      to.classList.add('is-active');
      this.current = index;
      if (focus) this.tabs[index]?.focus();
      return;
    }

    this.busy = true;
    from.classList.remove('is-active', 'is-entering');
    from.classList.add('is-leaving');
    from.setAttribute('aria-hidden', 'true');
    to.removeAttribute('hidden');
    to.classList.remove('is-leaving');
    to.classList.add('is-entering');
    to.setAttribute('aria-hidden', 'false');

    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      from.classList.remove('is-leaving');
      from.setAttribute('hidden', '');
      to.classList.remove('is-entering');
      to.classList.add('is-active');
      this.current = index;
      this.busy = false;
      if (focus) this.tabs[index]?.focus();
      if (this.queued != null && this.queued !== this.current) {
        const next = this.queued;
        this.queued = null;
        this.select(next, { focus });
      }
    }, this.animMs() + 80);
  }

  onKey(event, index) {
    let next = index;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = this.tabs.length - 1;
    else return;
    event.preventDefault();
    this.select(next, { focus: true });
  }
}

if (!customElements.get('hm-product-tabs')) {
  customElements.define('hm-product-tabs', HmProductTabs);
}
